import {useSelector} from "react-redux";
import {CustomSelectAndChildren} from "../../../../../components/CustomSelectAndChildren";
import {MenuItem} from "@mui/material";
import {CustomDatePicker} from "../../../../../components/CustomDatePicker";
import CustomSearch from "../../../../../components/SearchSimples/CustomSearch";
import React from "react";

/**
 * @Email : azapata@ibl.mx
 * @Author: Ferro Zapata Arnulfo
 * @jobTittle: Full Stack Developer
 *
 */
const IncomingInvitationSearch = ({item, handleChange, search, setSearch}) => {

    const { employeeWorkStations } = useSelector((state) => state.CompanyEmployeesSlice);

    const onReset = () => {
        setSearch("");
    }

    return (<div className='row'>
        <div className='col-sm-12 col-md-3 col-lg-3 col-xl-3'>
            <CustomSelectAndChildren
                id="slt_iis_zone"
                label="lbl_cud_zone"
                name='zone'
                trans='select_a_zone'
                value={item?.zone || ''}
                onChange={handleChange}
                showNoSelectionOption={true}
            >
                {employeeWorkStations?.map((item) => (
                    <MenuItem key={item.id} value={item}>
                        {item.name}
                    </MenuItem>
                ))}
            </CustomSelectAndChildren>
        </div>
        <div className='col-sm-12 col-md-3 col-lg-3 col-xl-3'>
            <CustomDatePicker
                id={'dp_iss_date_filter'}
                name={'date'}
                disabled={false}
                trans={'select_a_date'}
                value={item?.date}
                required={false}
                disableFuture={false}
                openTo={'day'}
                onChange={(e) => {
                    handleChange({ target: { value: e, name: 'date' } });
                }}
            />
        </div>
        <div className='col-sm-12 col-md-6 col-lg-6 col-xl-6'>
            <CustomSearch id={'txt_iss_search'}
                          label={"search_by_name"}
                          value={search}
                          setValue={setSearch}
                          onChange={(e) => setSearch(e.target.value)}
                          onReset={()=>onReset()}
            />
        </div>
    </div>)

}


export default IncomingInvitationSearch
